import axios from 'axios';
import { BASE_URL } from 'utils/constants/Api';

import { SavedView } from '@project44-models/shipment-list';

export async function fetchSavedViews() {
  const data = await axios.get(`${BASE_URL}/saved-view/shipments`, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data?.data;
}

export async function createSavedView(body?: SavedView) {
  const data = await axios.post(`${BASE_URL}/saved-view/shipments`, body, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data?.data;
}

export async function deleteSavedView(id: string) {
  const data = await axios.delete(`${BASE_URL}/saved-view/shipments/${id}`, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data?.data;
}

export async function sortSavedViews(sortedViewIds: string[]) {
  const data = await axios.post(
    `${BASE_URL}/saved-view/shipments/sort`,
    {
      sortedViewIds,
    },
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return data?.data;
}

export async function updateSavedView(id: string, body?: SavedView) {
  const data = await axios.put(`${BASE_URL}/saved-view/shipments/${id}`, body, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data?.data;
}
